import ILead from "../interfaces/ILead";
import useFocusShape from "./useFocusShape";
import useLeadsInsideShape from "./useLeadsInsideShape";

export default function (leads: ILead[]): ILead[] {
    return useLeadsInsideShape(leads, useFocusShape());
}